<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN">Part One</p>
<p class="PEP">Sins cannot be undone, only forgiven.</p>
<p class="PEPC">—Igor Stravinsky</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?0c4bbe3e